import React, { memo } from 'react';
import styles from './InitiativeCard.module.scss';

import { SFCard } from 'sfui';
import { isEqualObject } from 'ui-smartforce-settings';

import { InitiativeValue } from '../../../../../../Models/InitiativeValue';
import { InitiativeMap } from './InitiativeMap/InitiativeMap';
import { InitiativeCardHeader } from './InitiativeCardHeader/InititativeCardHeader';
import { InitiativeCardInfo } from './InitiativeCardInfo/InitiativeCardInfo';
import { UseInitiativeCard } from './hooks/UseInitiativeCard';

export interface InitiativeCardProps {
  initiative: InitiativeValue;
}

export const InitiativeCard = memo(
  function ({
    initiative
  }: InitiativeCardProps): React.ReactElement<InitiativeCardProps> {
    const {
      isSeeRecentReportsBtnDisabled,
      onSeeDateRowReports,
      onSeeRecentReports
    } = UseInitiativeCard({ initiative });

    return (
      <SFCard sfElevation={2} containerClassName={styles.initiativeCard}>
        {!!initiative && (
          <div className={styles.initiativeCardContainer}>
            <InitiativeMap
              className={styles.leftMap}
              areas={initiative.areas}
            />

            <div className={styles.initiativeCardContent}>
              <InitiativeCardHeader
                className={styles.header}
                name={initiative.name}
                tags={initiative.tags}
                isButtonDisabled={isSeeRecentReportsBtnDisabled}
                onSeeRecentReports={onSeeRecentReports}
              />

              <InitiativeMap
                className={styles.topMap}
                areas={initiative.areas}
              />

              <InitiativeCardInfo
                className={styles.info}
                initiative={initiative}
                onSeeDateRowReports={onSeeDateRowReports}
              />
            </div>
          </div>
        )}
      </SFCard>
    );
  },
  (prevProps: InitiativeCardProps, nextProps: InitiativeCardProps) =>
    isEqualObject(prevProps.initiative, nextProps.initiative)
);
